import images from "./images";

const juices = [
  {
    title: "Orange and Carrot",
    price: "$6",
    tags: "Glass",
  },
  {
    title: "Apple",
    price: "$8",
    tags: "Glass",
  },
  {
    title: "Straberry",
    price: "$8",
    tags: "Glass",
  },
  {
    title: "Chocolate peanut butter",
    price: "$15",
    tags: "Nutella | Fresh milk | Butter | Glass",
  },
  {
    title: "Coffee and caramel",
    price: "$12",
    tags: "Black coffee | Fresh milk | Glass",
  },
];

const chaiOptions = [
  {
    title: "Karak Chai",
    price: "$6",
    tags: "Strong tea | Fresh milk | Cream | Cup",
  },
  {
    title: "Cardamom Chai",
    price: "$8",
    tags: "Cardamom | Fresh milk | Cream | Cup",
  },
  {
    title: "Doodh Patti",
    price: "$6",
    tags: "Sugar | More milk | Cream | Cup",
  },
  {
    title: "Nutella Chai",
    price: "$12",
    tags: "Nutella | Fresh milk | Cream | Cup",
  },
  {
    title: "Coffee Chai",
    price: "$12",
    tags: "Coffee | Tea | Fresh milk | Cream | Cup",
  },
];

export default { juices, chaiOptions };
